import $ from "jquery";

$(function() {
    $.pjax.defaults.timeout = 3000;
    $.pjax.defaults.scrollTo = false;
});
